import type { ReactNode } from 'react';

type Tone = 'green' | 'blue' | 'amber' | 'red' | 'muted' | 'onDark';

interface Props {
  tone?: Tone;
  children: ReactNode;
  className?: string;
}

const PALETTE: Record<Tone, { bg: string; fg: string; dot: string }> = {
  green:  { bg: 'rgba(0,192,114,0.12)',  fg: '#00A664',           dot: '#00C072' },
  blue:   { bg: 'rgba(0,144,226,0.12)',  fg: '#007ED2',           dot: '#0090E2' },
  amber:  { bg: 'rgba(255,185,42,0.18)', fg: '#B47308',           dot: '#FFB92A' },
  red:    { bg: 'rgba(238,38,62,0.10)',  fg: '#D5152B',           dot: '#EE263E' },
  muted:  { bg: 'rgba(0,27,116,0.05)',   fg: 'rgba(0,27,116,0.55)', dot: 'rgba(0,27,116,0.4)' },
  onDark: { bg: 'rgba(241,237,228,0.14)', fg: '#F1EDE4',          dot: '#00C072' }
};

export function StatusPill({ tone = 'green', children, className = '' }: Props) {
  const c = PALETTE[tone];
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-semibold leading-tight ${className}`}
      style={{ background: c.bg, color: c.fg, letterSpacing: '-0.005em' }}
    >
      <span
        className="inline-block h-1.5 w-1.5 rounded-full"
        style={{ background: c.dot }}
      />
      {children}
    </span>
  );
}
